export const environment = {
  production: true,
  authServer: 'https://gw.icareme.riatlas.it/authorization',
  resourceServer: 'https://gw.icareme.riatlas.it/resource',
  fhirServer: 'https://gw.icareme.riatlas.it/fhir',
  elastic: 'https://gw.icareme.riatlas.it/resource',
  mobile: 'https://gw.icareme.riatlas.it/mobile',
  company: 'Riatlas.it',
  baseHref: 'cloud'
};
